declare global {
  interface Window {
    _env_: {
      FILESTACK_API_KEY: string;
      API_URL: string;
      NODE_ENV: string;
      BASE_URL: string;
    };
    Tint?: {
      FormBuilder?: {
        renderForms?: () => void;
      };
    };
  }
}

export const sdkConfig = {
  REACT_APP_FILESTACK_API_KEY:
    typeof window !== 'undefined' && window._env_ ? window._env_.FILESTACK_API_KEY : 'APlRkFeSpQhGlhLqd8VZfz',
  REACT_APP_TINT_UP_URL_TINTS:
    typeof window !== 'undefined' && window._env_ ? window._env_.API_URL : 'https://api.tintup.com',
};

export default sdkConfig;
